import { Pipe, PipeTransform } from '@angular/core';
import { StringUtil } from "@pcp/core/util";

@Pipe({ name: 'lineBreaks' })
export class LineBreaksPipe implements PipeTransform {

    transform(input: string, ...args: unknown[]): string {
        return StringUtil.lineBreaks(input);
    }

}
